<template>
    <div id="htpage">
        <div id="toolH">
            <div  class="head flex_b">
                <h4>{{$t('purchaseOrder_contract_list')}}</h4>
                <i class="el-icon-close" @click="closecontent"></i>
            </div>
            <ul class="ul_tools ">
                <li class="pad3">
                    <el-input  style="width: 200px"  v-model="vc_search" :placeholder="$t('purchaseOrder_please_search_by_contract_number')" clearable size="mini"></el-input>
                </li>
                <li class="pad3">
                    <el-button  icon="el-icon-search" circle  size="mini" @click="gosearch"></el-button>
                </li>
            </ul>
        </div>

        <!--表单部分-->
        <div  class="tableHeight">
            <el-table
                    v-loading="loading"
                    ref="table"
                    class="mrt10"
                    size="mini"
                    border
                    :data="tableData"
                    :height="tableHeight"
                    :header-cell-style="{background:'#eef1f6',color:'#000'}"
                    @row-click="rowClick"
                    :highlight-current-row="highlightCurrentRow">
                <el-table-column
                        type="index"
                        :label="$t('form_serial_number')"
                        width="35">
                </el-table-column>
                <el-table-column
                        prop="vc_fno"
                        :label="$t('purchaseOrder_contract_no')"
                        width="160">
                </el-table-column>
                <el-table-column
                        prop="vc_gysname"
                        :label="$t('purchaseOrder_supplier')"
                        width="200">
                </el-table-column>
                <el-table-column
                        prop="i_xtype"
                        :label="$t('purchaseOrder_nature_of_goods')"
                        width="50">
                    <template slot-scope="scope">
                        <span>{{scope.row.i_xtype==0?$t('form_domestic_sales'):$t('form_export')}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="i_htstate"
                        :label="$t('form_status')"
                        width="80">
                    <template slot-scope="scope">
                        <span>{{scope.row.i_htstate==0?$t('state_not_submitted'):(scope.row.i_htstate==1?$t('state_approved'):(scope.row.i_htstate==2?$t('state_completed'):(scope.row.i_htstate==-1?$t('purchaseOrder_customer_termination'):(scope.row.i_htstate==-2?$t('purchaseOrder_our_company_terminates'):(scope.row.i_htstate==3?$t('state_reviewing'):(scope.row.i_htstate==-3?$t('state_not_approved'):(scope.row.i_htstate==-4?$t('state_invalid'):(scope.row.i_htstate==33?$t('purchaseOrder_waiting_for_the_contract_to_take_effect'):($t('purchaseOrder_waiting_for_customer_feedback'))))))))))}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        width="80"
                        fixed="right"
                        :label="$t('form_operate')">
                    <template slot-scope="scope" v-if="scope.row.i_htstate==1">
<!--                        v-show="scope.row.vc_paytype=='开证'&&scope.row.vc_xyno!=''"-->
                        <el-button  type="text" size="small" @click="addClick(scope.row)">{{$t('button_newly_added')}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    class="fr mrr9"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 15, 30]"
                    :page-size="pageSize"
                    layout="sizes, prev, pager, next"
                    :total="tableTotal">
            </el-pagination>
        </div>
    </div>
</template>


<script>
    import * as API from "./api";
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "htList",
        data() {
            return {
                loading:true,
                vc_search:"",
                tableData:[],
                pageSize:15,
                currentPage:1,
                tableTotal:0,
                highlightCurrentRow:false,
                tableHeight:0,
                baseerp:"",
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            //console.log("????????????????????????????????????????")
            this.baseerp=baseerp;
            this.gethtlist();
            this.$nextTick(function () {
                //window.addEventListener('resize',this.heightAuto);
                //this.heightAuto();
                this.onResize();
            });


        },
        methods:{
            closecontent(){
                this.$emit('closetent','ht')
            },

            gosearch(){
                //console.log("vc_search",this.vc_search)
                this.currentPage=1;
                this.tableData=[];
                this.gethtlist();
            },
            addClick(row){
                //console.log("row",row)
                //0807注掉if(row.vc_paytype=='开证'&&row.vc_xyno==''){
                //    this.$message.error(this.$t('purchaseOrder_no_new_order_can_be_added_without_opening_the_letter_of_credit_contract'));
                //}else{
                    this.$emit('opendia',row,"add")
                //}


            },

            handleSizeChange(val){
                //console.log(val,"page_count");
                this.pageSize=val;
                this.currentPage=1;
                ///调用列表接口
                this.gethtlist();
            },
            handleCurrentChange(val){
                //console.log(val,"page_size");
                this.currentPage=val;
                ///调用列表接口
                this.gethtlist();
            },


            //拿到当前行数据
            rowClick(row){
                this.highlightCurrentRow=true;
                //console.log(row,"row");
                this.$emit('opendia',row,"list")
            },
           /* heightAuto(){
                console.log(" $(\".htpage\").height()*1", $(".htpage").height()*1);
                //console.log("window.innerHeight", window.innerHeight)
                this.tableHeight = window.innerHeight - this.$refs.table.$el.clientTop - 280 -  $("#toolbar").height()*1 - 30;
               // console.log(" $(\"#toolbar\").height()*1", $("#toolbar").height()*1);

            },*/

            /*onResize (){
                // $(".tableHeight").height($(".htpage").height()*1 -  $("#toolbar").height()*1-  $("#title").height()*1);
                this.tableHeight = $(".htpage").height()*1 -  $("#toolbar").height()*1 - 28 - 36
                //console.log(" $(\".htpage\").height()*1", $(".htpage").height()*1);
                console.log("this.tableHeight-----------------------",this.tableHeight)
            },*/
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                //console.log("n",n)
                //$("#htpage").height(n.h);
                //$("#htpage").width(n.w);
                //this.tableHeight= n.h-80;
                this.tableHeight = $("#htpage").height()*1 -  $("#toolH").height()*1 - 70;
                //console.log($("#htpage").height()*1,"------------")
                //console.log($("#toolH").height()*1,"=================")
                //console.log(this.tableHeight,"????????????????")
                //$(".sp_content").height($(".sphome").height()*1 -  $("#toolbar").height()*1);
                //console.log("sp_content-height",$(".sp_content").height)
                //this.tableHeight = $(".sp_content").height
            },

            //合同列表
            async gethtlist(pageSize){
                this.loading=true;
                if(pageSize!=undefined) {
                    //console.log(pageSize,"addddd")
                    this.currentPage=pageSize;
                }
                let param = {
                    vc_search:this.vc_search,
                    page_count:this.pageSize,
                    page_size:this.currentPage,

                };
                //console.log("htparam",param);
                let res = await API.getHtList(param);
                if (res.code == 1) {
                    this.loading=false;
                    this.tableData=res.data;
                    this.tableTotal=res.total;
                } else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },

        },
    }
</script>

<style  lang="scss" >
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .mrr9{
        margin-right: 9px;
    }
    .fr{
        float: right;
    }
    .pad3{
        padding: 3px;
    }

    .flex{
        display: flex;
    }
    .mrl20{
        margin-left: 20px;
    }

    .ul_tools {
        display: flex;
        float: left;
    }
    .head{
        display: flex;
        align-items: center;
        padding: 0 20px;
        background: var(--light);
        justify-content: space-between;
        height: 30px;
        color: var(--whiteColor);
    }
</style>